// // src/App.tsx
// import React, { CSSProperties } from 'react';
// import Navbar from './components/Navbar';
// import Hero from './components/Hero';
// import Services from './components/Services';
// import HowItWorks from './components/HowItWorks';
// import Testimonials from './components/Testimonials';
// import CTA from './components/CTA';
// import Footer from './components/Footer';
// import FAQ from './components/FAQ';

// // Primary color defined as a constant
// const PRIMARY_COLOR = '#3498db';
// const PRIMARY_DARK = '#2980b9';
// document.documentElement.style.scrollBehavior = 'smooth';


// const App: React.FC = () => {
//   return (
//     <div style={styles.appContainer}>
  

//       <Navbar/>
 

      








//       <div id="home">
//   <Hero />
// </div>

// <div id="services">
//   <Services />
// </div>

// <div id="how-it-works">
//   <HowItWorks />
// </div>


// <div id="testimonials">
//   <Testimonials />
// </div>



// <div id="cta">
//   <CTA />
// </div>
// <div id="faq">
//   <FAQ />
// </div>





//       <Footer/>
//     </div>
//   );
// };






// // Define a type for our styles object
// type Styles = Record<string, CSSProperties>;

// // Styles object with proper typing
// const styles: Styles = {
//   appContainer: {
//     minHeight: '100vh',
//     backgroundColor: '#f9fafb',
//     fontFamily: "'Inter', sans-serif",
//     color: '#333',
//   },
  
 
  
// };


// export default App;











// src/App.tsx
import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';

import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Services from './components/Services';
import Testimonials from './components/Testimonials';
import CTA from './components/CTA';
import Footer from './components/Footer';
import FAQ from './components/FAQ';

import TermsAndConditions from './components/Terms&Conditions'; // Import your new component
import PrivacyPolicy from './components/PrivacyPolicy';
import ScrollToHashElement from './components/ScrollToHashElement';
import HowInstashipWorks from './components/HowInstashipWorks';
import PlatformShowcase from './components/PlatformShowcase';
import ClientLogos from './components/ClientLogos';
import RedirectPage from './components/RedirectPage';
import TrackingScreen from './components/Tracking';
import DeliverySignature from './components/DeliverySignature';
import GetBilty from './components/GetBilty';

// ── Preload above-the-fold images immediately at module evaluation time ──
// This fires HTTP requests as soon as the JS bundle runs, before any
// component renders, shaving ~2-3 s off the visible loading delay.
import _heroBg from './assets/hero-bg.png';
import _heroPhone from './assets/hero-phone.png';
import _howItWorks from './assets/how-it-works.png';
import _howItWorksPhone from './assets/how-it-works-phone.png';
[_heroBg, _heroPhone, _howItWorks, _howItWorksPhone].forEach(src => {
  const img = new window.Image();
  img.src = src;
});

const App: React.FC = () => {
  return (
    // <Router>
    //   <div style={styles.appContainer}>
    //     <Navbar />

    //     <Routes>
    //       {/* Main Website */}
    //       <Route
    //         path="/"
    //         element={
    //           <>
    //             <div id="home"><Hero /></div>
    //             <div id="services"><Services /></div>
    //             <div id="how-it-works"><HowItWorks /></div>
    //             <div id="testimonials"><Testimonials /></div>
    //             <div id="cta"><CTA /></div>
    //             <div id="faq"><FAQ /></div>
    //             <Footer />
    //           </>
    //         }
    //       />

    //       {/* Terms & Conditions Page */}
    //       <Route path="/terms-of-service" element={<TermsAndConditions />} />
    //     </Routes>
    //   </div>
    // </Router>









    <Router>
          <ScrollToHashElement />
  <div style={styles.appContainer}>
    <Navbar />

    <div style={{ flex: 1 }}>
      <Routes>

      <Route path="/" element={
        <>
          <div id="home"><Hero /></div>
          <ClientLogos />
          <div id="how-it-works"><HowInstashipWorks /></div>
          <PlatformShowcase />
          <div id="testimonials"><Testimonials /></div>
          <div id="cta"><CTA /></div>
          <div id="faq"><FAQ /></div>
        </>
      } />
      <Route path="/terms-of-service" element={<TermsAndConditions />} />
      <Route path="/privacy-policy" element={<PrivacyPolicy />} />
      <Route path="/app-redirect" element={<RedirectPage />} />
      <Route path="/tracking" element={<TrackingScreen />} />
      <Route path="/tracking/:lrn" element={<TrackingScreen />} />
      <Route path="/delivery-signature/:token" element={<DeliverySignature />} />
      <Route path="/delivery-signature/demo" element={<DeliverySignature />} />
      <Route path="/getBilty/:token" element={<GetBilty />} />
      <Route path="/card-redirect" element={<Navigate to="/" replace />} />
    </Routes>
    </div>

    {/* Footer shown on all pages */}
    <Footer />
  </div>
</Router>

  );
};

const styles = {
  appContainer: {
    minHeight: '100vh',
    display: 'flex',
    flexDirection: 'column' as const,
    backgroundColor: '#f9fafb',
    fontFamily: "'Inter', sans-serif",
    color: '#333',
  },
};

export default App;
